import type { Translations } from './translations';

// Oleada de idiomas 2026-07-25 (estudio de mercado de Whiteout Survival):
// RU (demanda probada), KO (~36% del revenue), ZH-TW (Taiwán/HK top-5),
// JA (top-3), TR (comunidad grande). Sin `vs` ni `pricing` (copy retirado/
// muerto, opcional en la interfaz). El blog sigue EN/ES (SEO EN-first).

export const ru: Translations = {
  nav: { products: 'Продукты', how: 'Как это работает', pricing: 'Цены', faq: 'FAQ', contact: 'Контакты', enter: 'Войти' },
  hero: {
    badge: '5 дней бесплатно · Без обязательств',
    tagline: [
      'Бот для Whiteout Survival, который защищает ваш город, пока вы спите —',
      'Авто-щит замечает атаки, ставит щит и отзывает войска.',
      'Работает на вашем ПК. Управляется с телефона.',
    ],
    cta1: 'Попробовать 5 дней бесплатно',
    cta2: 'Как это работает ↓',
  },
  stats: {
    s1v: '24/7', s1l: 'Бот работает на вашем ПК',
    s2v: '100% веб', s2l: 'Управление с любого устройства',
    s3v: '0 подтверждённых банов', s3l: 'Среди наших пользователей',
    s4v: '5 дней', s4l: 'Бесплатно, отмена в любой момент',
  },
  products: {
    title: 'Выберите свой White Bot',
    sub: 'Один и тот же бот — два способа запуска.',
    downloadable: {
      badge: 'Доступно сейчас',
      name: 'White Bot Desktop',
      desc: 'Бот работает на вашем ПК с Windows и BlueStacks. Вы устанавливаете его сами — и управляете всем через веб, где бы вы ни были.',
      features: [
        'Работает на вашем ПК (Windows + BlueStacks)',
        'Полное управление через веб',
        'Сбор, обучение войск, охота и Авто-щит',
        '🔍 Разведка: 5 запросов в день включено',
        '5 дней бесплатно — без карты',
      ],
      priceNote: '€11,99/мес после пробного периода',
      cta: 'Попробовать 5 дней бесплатно',
    },
    cloud: {
      badge: 'В разработке — закрытая бета',
      name: 'White Bot Cloud',
      desc: 'Мы запускаем бота за вас на наших серверах, 24/7, без установки. Сейчас в закрытой бете, пока мы его дорабатываем.',
      features: [
        'Мы запускаем его за вас, 24/7',
        'Ничего не устанавливать — ПК не нужен',
        'Полная безлимитная разведка',
        'Мест ограниченно',
      ],
      priceNote: 'От €49,99/мес после открытия',
      notifyLabel: 'Интересно? Напишем на почту, когда откроемся:',
      betaAccess: 'Уже в закрытой бете? Войти',
    },
  },
  cloudNotify: {
    emailPh: 'you@email.com',
    submit: 'Сообщить об открытии',
    submitting: 'Отправляем…',
    successTitle: 'Вы в списке!',
    successBody: 'Мы напишем на этот адрес, когда White Bot Cloud откроет двери.',
    errorMsg: 'Не удалось отправить. Попробуйте ещё раз через минуту.',
  },
  forwhom: {
    yes: {
      title: 'Отлично подойдёт, если…',
      items: [
        'У вас уже есть развитый аккаунт Whiteout Survival',
        'У вас есть ПК с Windows, где может работать бот',
        'Вы хотите прогрессировать, пока работаете, учитесь или спите',
        'Вы хотите управлять ботом с телефона, откуда угодно',
      ],
    },
    no: {
      title: 'Имейте в виду…',
      items: [
        'Боту нужен включённый ПК с запущенным BlueStacks, пока он работает',
        'White Bot не проходит обучение и не ведёт новые аккаунты',
        'Использование ботов может нарушать Условия обслуживания игры (см. FAQ)',
        'Игра должна быть на английском или испанском',
      ],
    },
  },
  compare: {
    title: 'Вручную vs White Bot',
    sub: 'Те же действия, что вы делаете сами — но 24 часа в сутки.',
    headers: ['', 'Играя вручную', 'С White Bot'],
    rows: [
      ['Активные часы', 'Только когда играете', '24 ч / 7 дней'],
      ['Сбор ресурсов', 'Ограничен вашими сессиями', 'Непрерывный и максимальный'],
      ['Очередь войск', 'Иногда простаивает', 'Всегда активна'],
      ['Охота на монстров', 'Несколько в день', 'Десятки циклов в день'],
      ['Ваше время', '2–3 часа в день', '0 часов'],
      ['Управление с телефона', 'Только само приложение игры', 'Полная панель в любом браузере'],
    ],
  },
  benefits: {
    title: 'Всё, что он делает за вас',
    sub: 'Реальные игровые действия, автоматизированные на вашем ПК.',
    items: [
      { title: 'Авто-сбор', desc: 'Собирает ресурсы на карте без вашего участия.' },
      { title: 'Обучение войск', desc: 'Держит очереди обучения всегда активными для максимального прогресса.' },
      { title: 'Авто-охота', desc: 'Непрерывно охотится на монстров, накапливая ценные предметы.' },
      { title: 'Авто-щит', desc: 'Следит за входящими атаками: бросает всё, активирует щит из рюкзака и отзывает войска в походе, оставаясь в защищённом режиме.' },
      { title: 'Разведка', desc: '5 запросов в день: мощь, координаты и последний онлайн любого игрока или альянса из сети White Bot.' },
      { title: 'Веб-панель управления', desc: 'Настраивайте, останавливайте и следите за ботом из любого браузера, включая телефон.' },
    ],
  },
  steps: {
    title: 'Как это работает',
    sub: 'От скачивания до работающего бота за минуты.',
    items: [
      { title: 'Создайте аккаунт и начните пробный период', desc: 'Зарегистрируйтесь на сайте продукта и начните свои 5 бесплатных дней.' },
      { title: 'Скачайте и установите клиент', desc: 'Windows + BlueStacks. Руководство проведёт вас по каждому шагу.' },
      { title: 'Активируйте по email', desc: 'Введите email и код активации в клиенте. Готово: клиент подключён.' },
      { title: 'Управляйте всем через веб', desc: 'Настраивайте действия, останавливайте и следите с любого устройства. Бот работает на вашем ПК.' },
    ],
  },
  trust: {
    title: 'Безопасность и приватность',
    sub: 'Устроено так, чтобы контроль всегда оставался у вас.',
    items: [
      { title: 'Без передачи паролей', desc: 'Вы сами привязываете игровой аккаунт в своём BlueStacks. Ваши данные не покидают ваш ПК.' },
      { title: 'Ваш ПК — ваш контроль', desc: 'Бот работает на вашей машине и связывается с нашими серверами только для проверки лицензии и работы панели.' },
      { title: 'Без привязки', desc: 'Отменяйте в любой момент через веб. Доступ сохраняется до конца оплаченного периода.' },
      { title: 'Безопасные платежи через Stripe', desc: 'Платежи обрабатывает Stripe. Данные вашей карты не попадают на наши серверы.' },
    ],
  },
  risk: {
    title: 'Честно о рисках',
    p1: 'White Bot автоматизирует игровые действия в эмуляторе на вашем ПК. Использование стороннего ПО может нарушать <strong>Условия обслуживания Whiteout Survival</strong> и повлечь санкции со стороны разработчика игры, включая ограничение или блокировку аккаунта. Риск лежит на вашем аккаунте и вашей машине.',
    p2: 'Бот запрограммирован вести себя как живой игрок: переменные тайминги, естественные паузы, реалистичные циклы. <strong>На сегодня среди наших пользователей нет ни одного подтверждённого бана.</strong> Риск всё равно существует, и, используя продукт, пользователь его принимает. См. наши <a href="/terms">Условия использования</a>.',
    termsLink: '/terms',
  },
  contact: {
    title: 'Есть вопрос?',
    sub: 'Напишите нам — ответим в течение 24 часов.',
    label: 'Или напишите напрямую:',
    fields: { name: 'Имя', email: 'Email', subject: 'Тема', message: 'Сообщение' },
    subjects: { consulta: 'Общий вопрос', soporte: 'Техническая поддержка', facturacion: 'Оплата / подписка', baneo: 'Сообщить о проблеме', otro: 'Другое' },
    submit: 'Отправить', submitting: 'Отправляем…',
    successTitle: 'Сообщение отправлено!', successBody: 'Ответим в течение 24 часов.',
    errorMsg: 'Ошибка отправки. Попробуйте ещё раз или напишите на whitebot.admin@gmail.com',
    namePh: 'Ваше имя', emailPh: 'you@email.com', messagePh: 'Расскажите, в чём вопрос…',
  },
  betaList: {
    title: 'Не пропустите бесплатную бету',
    body: 'Полный бот бесплатен до 15 августа 2026 — платные планы стартуют 16 августа. Оставьте email, и мы напомним до окончания.',
    emailPh: 'you@email.com',
    submit: 'Держите меня в курсе',
    submitting: 'Отправляем…',
    successTitle: 'Готово!',
    successBody: 'Мы напишем вам до окончания бесплатной беты.',
    errorMsg: 'Не удалось отправить. Попробуйте ещё раз через минуту.',
    supportNote: 'Вопросы? Напишите в чат поддержки в приложении — отвечаем быстро.',
  },
  beta: {
    hero: { badge: 'Бесплатная бета до 15 августа · Без обязательств', cta1: 'Присоединиться к бете' },
    stats: { s4v: 'Бесплатно', s4l: 'Бета до 15.08.2026 — без карты' },
    stepTrial: {
      title: 'Создайте аккаунт и присоединяйтесь к бете',
      desc: 'Зарегистрируйтесь на сайте продукта — бесплатно во время беты, без карты.',
    },
    downloadable: {
      badge: 'Бесплатная бета',
      trialFeature: 'Бесплатная бета до 15 августа 2026 — без карты',
      priceNote: 'Бесплатно до 15 августа 2026 — потом €11,99/мес',
      cta: 'Присоединиться к бете',
    },
    faq: {
      q: 'Что входит в бесплатную бету?',
      a: 'До 15 августа 2026 White Bot Desktop полностью бесплатен: создайте аккаунт, начните бету (карта не нужна) и пользуйтесь полным ботом. 16 августа включается обычная модель — 5-дневный пробный период для новых пользователей и подписка €11,99/мес. Участникам беты мы напишем до её окончания.',
    },
  },
  faq: {
    title: 'Частые вопросы',
    items: [
      { q: 'Что нужно, чтобы пользоваться White Bot?', a: 'ПК с Windows, бесплатный эмулятор BlueStacks и ваш аккаунт Whiteout Survival. Бот устанавливается на ПК, а управляется через веб с любого устройства.' },
      { q: 'Нужно ли что-то устанавливать?', a: 'Да. В отличие от облачных ботов, White Bot работает на вашем собственном ПК: вы устанавливаете клиент и BlueStacks по пошаговому руководству. Повседневное управление — полностью через веб, ПК трогать не нужно.' },
      { q: 'Работает ли бот при выключенном ПК?', a: 'Нет. Бот работает на вашем ПК, поэтому машина должна быть включена с открытым BlueStacks. Браузер можно закрыть и управлять ботом удалённо в любой момент; но работать при выключенной машине он не может.' },
      { q: 'Подходит ли для новых аккаунтов?', a: 'Нет. White Bot создан для игроков с развитыми аккаунтами. Система не проходит обучение и не создаёт аккаунты. Ваш аккаунт должен быть полностью готов к игре до использования бота.' },
      { q: 'Могут ли меня забанить за White Bot?', a: 'Да, риск есть всегда. Использование автоматизации может нарушать Условия обслуживания Whiteout Survival. White Bot запрограммирован имитировать поведение живого игрока: случайные тайминги, естественные паузы, реалистичные циклы. На сегодня подтверждённых банов среди наших пользователей нет. Бот работает на вашем ПК с вашим аккаунтом: риск ваш, и вы явно его принимаете (см. Условия использования).' },
      { q: 'Что будет, если меня забанят?', a: 'White Bot предоставляет ПО для автоматизации; он не гарантирует игровые результаты или безопасность аккаунта перед разработчиком игры. При санкциях мы рассматриваем каждый случай отдельно. Бан, явно вызванный нашей технической ошибкой, рассмотрим для соразмерного возврата. Баны из-за принятого в Условиях риска бота автоматический возврат не порождают.' },
      { q: 'Как привязать игровой аккаунт?', a: 'Вы делаете это сами: входите в свой аккаунт внутри BlueStacks точно так же, как на телефоне. Мы никогда не видим и не храним ваши данные — они не покидают ваш ПК.' },
      { q: 'Что входит в 5-дневный пробный период?', a: '5 дней ПОЛНОГО бота, без карты. Создайте аккаунт, нажмите «Начать пробный период» и скачайте клиент — платёжные данные не нужны. Когда период закончится, бот остановится; если понравилось, подпишитесь за €11,99/мес и продолжите с того же места (настройки сохраняются). Один пробный период на аккаунт и на ПК.' },
      { q: 'Как работает Авто-щит?', a: 'Пока бот работает, он следит за входящими атаками. Подтвердив атаку, он всё останавливает, активирует щит из рюкзака, отзывает войска в походе и остаётся в защищённом режиме, пока вы не вернётесь. Учтите: он использует щиты, которые уже есть в рюкзаке (не покупает их), и не даёт абсолютной гарантии от мгновенных атак.' },
      { q: 'На каком языке должна быть игра?', a: 'Английский или испанский. Настроенный язык игры можно поменять через веб в любой момент.' },
      { q: 'Могу ли я в любой момент остановить бота?', a: 'Да. Из веб-панели можно остановить, приостановить или перенастроить бота мгновенно, с любого устройства.' },
      { q: 'Как отменить подписку?', a: 'Отменить можно в любой момент через веб. Доступ сохраняется до конца оплаченного периода. Без привязки и штрафов.' },
      { q: 'Что такое White Bot Cloud?', a: 'Это облачная версия: бот работает на наших серверах 24/7, без установки, с полной безлимитной разведкой по регионам (в Desktop входит 5 запросов в день). Она в разработке, в закрытой бете. После открытия это будет премиум-уровень (от €49,99/мес). Оставьте email в разделе продуктов — сообщим.' },
    ],
  },
  blog: {
    sectionTitle: 'Гайды и стратегии',
    sectionSub: 'Узнайте, как расти быстрее в Whiteout Survival.',
    readMore: 'Читать гайд →',
    viewAll: 'Все гайды',
  },
  footer: {
    copy: '© 2026 White Bot · Не аффилирован с Whiteout Survival или Century Games',
    links: { enter: 'Войти', faq: 'FAQ', contact: 'Контакты', privacy: 'Политика конфиденциальности', terms: 'Условия использования', blog: 'Блог', status: 'Статус' },
  },
};

export const ko: Translations = {
  nav: { products: '제품', how: '작동 방식', pricing: '가격', faq: 'FAQ', contact: '문의', enter: '로그인' },
  hero: {
    badge: '5일 무료 체험 · 약정 없음',
    tagline: [
      '당신이 자는 동안 도시를 지켜주는 Whiteout Survival 봇 —',
      '자동 보호막이 공격을 감지해 보호막을 켜고 부대를 회군시킵니다.',
      '내 PC에서 실행. 휴대폰으로 제어.',
    ],
    cta1: '5일 무료 체험하기',
    cta2: '작동 방식 보기 ↓',
  },
  stats: {
    s1v: '24/7', s1l: '내 PC에서 봇이 작동',
    s2v: '100% 웹', s2l: '어떤 기기에서든 제어',
    s3v: '확인된 밴 0건', s3l: '전체 사용자 기준',
    s4v: '5일', s4l: '무료 체험, 언제든 해지',
  },
  products: {
    title: '당신의 White Bot을 선택하세요',
    sub: '같은 봇, 두 가지 실행 방식.',
    downloadable: {
      badge: '지금 이용 가능',
      name: 'White Bot Desktop',
      desc: '봇은 Windows와 BlueStacks가 설치된 당신의 PC에서 실행됩니다. 직접 설치하고 소유하며 — 어디서든 웹으로 모든 것을 제어합니다.',
      features: [
        '내 PC에서 실행 (Windows + BlueStacks)',
        '웹에서 완전한 제어',
        '채집, 병력 훈련, 사냥, 자동 보호막',
        '🔍 정보: 하루 5회 조회 포함',
        '5일 무료 체험 — 카드 불필요',
      ],
      priceNote: '체험 후 월 €11.99',
      cta: '5일 무료 체험하기',
    },
    cloud: {
      badge: '개발 중 — 비공개 베타',
      name: 'White Bot Cloud',
      desc: '저희 서버에서 봇을 24/7 대신 실행해 드립니다. 설치할 것이 없습니다. 완성될 때까지 비공개 베타로 운영 중입니다.',
      features: [
        '저희가 24/7 대신 실행',
        '설치 제로 — PC 불필요',
        '완전한 무제한 정보 기능',
        '한정된 자리',
      ],
      priceNote: '오픈 시 월 €49.99부터',
      notifyLabel: '관심 있으세요? 오픈하면 이메일로 알려드립니다:',
      betaAccess: '이미 비공개 베타 참여 중이신가요? 로그인',
    },
  },
  cloudNotify: {
    emailPh: 'you@email.com',
    submit: '오픈하면 알려주세요',
    submitting: '전송 중…',
    successTitle: '명단에 등록되었습니다!',
    successBody: 'White Bot Cloud가 문을 열면 이 이메일로 연락드리겠습니다.',
    errorMsg: '전송할 수 없습니다. 잠시 후 다시 시도하세요.',
  },
  forwhom: {
    yes: {
      title: '이런 분께 딱 맞습니다…',
      items: [
        '이미 성장한 Whiteout Survival 계정이 있는 분',
        '봇을 돌릴 Windows PC가 있는 분',
        '일하거나 공부하거나 자는 동안에도 성장하고 싶은 분',
        '어디서든 휴대폰으로 봇을 제어하고 싶은 분',
      ],
    },
    no: {
      title: '참고하세요…',
      items: [
        '봇이 작동하는 동안 PC가 켜져 있고 BlueStacks가 실행 중이어야 합니다',
        'White Bot은 튜토리얼이나 신규 계정을 다루지 않습니다',
        '봇 사용은 게임 서비스 약관에 위배될 수 있습니다 (FAQ 참조)',
        '게임 언어는 영어 또는 스페인어여야 합니다',
      ],
    },
  },
  compare: {
    title: '수동 플레이 vs White Bot',
    sub: '직접 하는 것과 같은 행동 — 단, 하루 24시간.',
    headers: ['', '수동 플레이', 'White Bot 사용'],
    rows: [
      ['활동 시간', '플레이할 때만', '24시간 / 7일'],
      ['자원 채집', '접속 시간에 한정', '지속적, 최대화'],
      ['병력 대기열', '가끔 비어 있음', '항상 가동'],
      ['몬스터 사냥', '하루 몇 번', '하루 수십 사이클'],
      ['들어가는 내 시간', '매일 2–3시간', '0시간'],
      ['모바일 제어', '게임 앱만', '모든 브라우저에서 전체 패널'],
    ],
  },
  benefits: {
    title: '봇이 대신해 주는 모든 것',
    sub: '내 PC에서 자동화되는 실제 게임 액션.',
    items: [
      { title: '자동 채집', desc: '게임을 열지 않아도 지도에서 자원을 채집합니다.' },
      { title: '병력 훈련', desc: '훈련 대기열을 항상 가동해 성장을 극대화합니다.' },
      { title: '자동 사냥', desc: '몬스터를 계속 사냥해 귀중한 아이템을 모읍니다.' },
      { title: '자동 보호막', desc: '들어오는 공격을 감시합니다: 모든 것을 멈추고 가방의 보호막을 활성화하며 행군 중인 부대를 회군시켜 보호 모드를 유지합니다.' },
      { title: '정보', desc: '하루 5회 조회: White Bot 네트워크에서 모든 플레이어·연맹의 전투력, 좌표, 최근 접속.' },
      { title: '웹 제어 패널', desc: '휴대폰을 포함한 모든 브라우저에서 봇을 설정하고 멈추고 모니터링하세요.' },
    ],
  },
  steps: {
    title: '작동 방식',
    sub: '다운로드부터 봇 가동까지 몇 분.',
    items: [
      { title: '계정을 만들고 체험 시작', desc: '제품 사이트에서 가입하고 5일 무료를 시작하세요.' },
      { title: '클라이언트 다운로드 및 설치', desc: 'Windows + BlueStacks. 설치 가이드가 모든 단계를 안내합니다.' },
      { title: '이메일로 활성화', desc: '클라이언트에 이메일과 활성화 코드를 입력하세요. 끝: 클라이언트 연결됨.' },
      { title: '웹에서 모두 제어', desc: '어떤 기기에서든 동작을 설정하고 멈추고 모니터링하세요. 봇은 당신의 PC에서 일합니다.' },
    ],
  },
  trust: {
    title: '보안과 개인정보',
    sub: '통제권이 항상 당신에게 있도록 설계되었습니다.',
    items: [
      { title: '비밀번호 공유 없음', desc: '자신의 BlueStacks에서 직접 게임 계정을 연결합니다. 자격 증명은 PC를 떠나지 않습니다.' },
      { title: '내 PC, 내 통제', desc: '봇은 당신의 컴퓨터에서 실행되며, 라이선스 확인과 패널 구동을 위해서만 저희 서버와 통신합니다.' },
      { title: '약정 없음', desc: '웹에서 언제든 해지하세요. 결제한 기간이 끝날 때까지 이용은 유지됩니다.' },
      { title: 'Stripe 안전 결제', desc: '결제는 Stripe가 처리합니다. 카드 정보는 저희 서버에 닿지 않습니다.' },
    ],
  },
  risk: {
    title: '위험에 대한 투명한 안내',
    p1: 'White Bot은 당신의 PC에서 실행되는 에뮬레이터 안에서 게임 액션을 자동화합니다. 서드파티 소프트웨어 사용은 <strong>Whiteout Survival 서비스 약관</strong>에 위배될 수 있으며, 계정 제한이나 정지를 포함한 게임 개발사의 제재로 이어질 수 있습니다. 위험은 당신의 계정과 컴퓨터가 부담합니다.',
    p2: '봇은 사람처럼 플레이하도록 프로그래밍되어 있습니다: 가변적인 행동 타이밍, 자연스러운 멈춤, 현실적인 사이클. <strong>현재까지 사용자 중 확인된 밴은 없습니다.</strong> 그래도 위험은 존재하며, 제품을 사용함으로써 사용자가 이를 수용합니다. <a href="/terms">이용 약관</a>을 참조하세요.',
    termsLink: '/terms',
  },
  contact: {
    title: '궁금한 점이 있으세요?',
    sub: '메시지를 보내주시면 24시간 안에 답변드립니다.',
    label: '또는 직접 이메일 주세요:',
    fields: { name: '이름', email: '이메일', subject: '제목', message: '메시지' },
    subjects: { consulta: '일반 문의', soporte: '기술 지원', facturacion: '결제 / 구독', baneo: '문제 신고', otro: '기타' },
    submit: '메시지 보내기', submitting: '전송 중…',
    successTitle: '메시지가 전송되었습니다!', successBody: '24시간 안에 답변드리겠습니다.',
    errorMsg: '전송 오류. 다시 시도하거나 whitebot.admin@gmail.com으로 메일 주세요.',
    namePh: '이름', emailPh: 'you@email.com', messagePh: '궁금한 점을 알려주세요…',
  },
  betaList: {
    title: '무료 베타를 놓치지 마세요',
    body: '2026년 8월 15일까지 전체 봇이 무료입니다 — 유료 플랜은 8월 16일 시작. 이메일을 남기시면 종료 전에 알려드립니다.',
    emailPh: 'you@email.com',
    submit: '소식 받기',
    submitting: '전송 중…',
    successTitle: '완료!',
    successBody: '무료 베타 종료 전에 이메일 드리겠습니다.',
    errorMsg: '전송할 수 없습니다. 잠시 후 다시 시도하세요.',
    supportNote: '질문이 있나요? 앱 내 지원 채팅으로 문의하세요 — 빠르게 답변합니다.',
  },
  beta: {
    hero: { badge: '8월 15일까지 무료 베타 · 약정 없음', cta1: '무료 베타 참여하기' },
    stats: { s4v: '무료', s4l: '2026년 8월 15일까지 베타 — 카드 불필요' },
    stepTrial: {
      title: '계정을 만들고 베타에 참여하세요',
      desc: '제품 사이트에서 가입하세요 — 베타 기간 동안 무료, 카드 불필요.',
    },
    downloadable: {
      badge: '무료 베타',
      trialFeature: '2026년 8월 15일까지 무료 베타 — 카드 불필요',
      priceNote: '2026년 8월 15일까지 무료 — 이후 월 €11.99',
      cta: '무료 베타 참여하기',
    },
    faq: {
      q: '무료 베타에는 무엇이 포함되나요?',
      a: '2026년 8월 15일까지 White Bot Desktop은 완전히 무료입니다: 계정을 만들고 베타를 시작하면(카드 불필요) 전체 봇을 사용할 수 있습니다. 8월 16일부터는 일반 모델이 적용됩니다 — 신규 사용자 5일 체험과 월 €11.99 구독. 베타 사용자에게는 종료 전에 이메일을 드립니다.',
    },
  },
  faq: {
    title: '자주 묻는 질문',
    items: [
      { q: 'White Bot을 쓰려면 무엇이 필요한가요?', a: 'Windows PC, 무료 에뮬레이터 BlueStacks, 그리고 당신의 Whiteout Survival 계정. 봇은 PC에 설치되고 어떤 기기에서든 웹으로 제어합니다.' },
      { q: '설치가 필요한가요?', a: '네. 클라우드 봇과 달리 White Bot은 당신의 PC에서 실행됩니다: 단계별 가이드에 따라 클라이언트와 BlueStacks를 설치합니다. 일상적인 제어는 100% 웹 기반 — PC를 만질 필요가 없습니다.' },
      { q: 'PC를 꺼도 봇이 작동하나요?', a: '아니요. 봇은 당신의 PC에서 실행되므로 BlueStacks가 열린 채 컴퓨터가 켜져 있어야 합니다. 브라우저는 닫고 언제든 원격으로 제어할 수 있지만, 컴퓨터가 꺼진 상태로는 일할 수 없습니다.' },
      { q: '신규 계정에서도 되나요?', a: '아니요. White Bot은 성장한 계정을 가진 플레이어용입니다. 시작 튜토리얼이나 계정 생성은 다루지 않습니다. 봇을 쓰기 전에 계정이 완전히 준비되어 있어야 합니다.' },
      { q: 'White Bot을 쓰면 밴당할 수 있나요?', a: '네, 내재된 위험이 있습니다. 자동화 소프트웨어 사용은 Whiteout Survival 서비스 약관에 위배될 수 있습니다. White Bot은 사람의 플레이를 모방하도록 만들어졌습니다: 무작위 행동 타이밍, 자연스러운 멈춤, 현실적인 사이클. 현재까지 확인된 밴은 없습니다. 봇은 당신의 PC에서 당신의 계정으로 실행됩니다: 위험은 당신의 몫이며 이를 명시적으로 수용합니다(이용 약관 참조).' },
      { q: '밴당하면 어떻게 되나요?', a: 'White Bot은 자동화 소프트웨어를 제공할 뿐, 게임 내 결과나 개발사에 대한 계정 안전을 보장하지 않습니다. 제재가 발생하면 사례별로 검토합니다. 저희 기술적 오류로 명백히 발생한 밴은 비례적 환불을 검토합니다. 이용 약관에서 수용한 봇 고유의 위험으로 인한 밴은 자동 환불 대상이 아닙니다.' },
      { q: '게임 계정은 어떻게 연결하나요?', a: '직접 하시면 됩니다: 휴대폰에서 하듯 BlueStacks 안에서 계정에 로그인하세요. 저희는 자격 증명을 보지도 저장하지도 않습니다 — PC를 떠나지 않습니다.' },
      { q: '5일 체험에는 무엇이 포함되나요?', a: '카드 없이 전체 봇 5일. 계정을 만들고 "무료 체험 시작"을 누른 뒤 클라이언트를 다운로드하세요 — 결제 정보를 묻지 않습니다. 체험이 끝나면 봇이 멈춥니다. 마음에 들면 월 €11.99에 구독하고 그대로 이어가세요(설정 유지). 체험은 계정당·PC당 1회.' },
      { q: '자동 보호막은 어떻게 작동하나요?', a: '봇이 일하는 동안 들어오는 공격을 감시합니다. 공격이 확인되면 모든 것을 멈추고 가방의 보호막을 활성화하며 행군 중인 부대를 회군시키고, 재개할 때까지 보호 모드를 유지합니다. 참고: 이미 가방에 있는 보호막을 사용하며(구매하지 않음), 순간 공격에 대한 절대적 보장은 아닙니다.' },
      { q: '게임 언어는 무엇이어야 하나요?', a: '영어 또는 스페인어. 설정된 게임 언어는 언제든 웹에서 바꿀 수 있습니다.' },
      { q: '봇을 언제든 멈출 수 있나요?', a: '네. 웹 패널에서 어떤 기기로든 즉시 봇을 정지·일시정지·재설정할 수 있습니다.' },
      { q: '구독은 어떻게 해지하나요?', a: '웹에서 언제든 해지할 수 있습니다. 현재 결제 기간이 끝날 때까지 이용은 유지됩니다. 약정도 위약금도 없습니다.' },
      { q: 'White Bot Cloud는 무엇인가요?', a: '호스팅 버전입니다: 봇이 저희 서버에서 24/7 실행되며, 설치가 전혀 없고 지역 정보 기능이 무제한입니다(Desktop은 하루 5회 조회 포함). 현재 개발 중으로 비공개 베타입니다. 오픈하면 프리미엄 등급(월 €49.99부터)이 됩니다. 제품 섹션에 이메일을 남기시면 알려드립니다.' },
    ],
  },
  blog: {
    sectionTitle: '가이드 & 전략',
    sectionSub: 'Whiteout Survival에서 더 빨리 성장하는 법을 배우세요.',
    readMore: '가이드 읽기 →',
    viewAll: '모든 가이드 보기',
  },
  footer: {
    copy: '© 2026 White Bot · Whiteout Survival 또는 Century Games와 무관합니다',
    links: { enter: '로그인', faq: 'FAQ', contact: '문의', privacy: '개인정보 처리방침', terms: '이용 약관', blog: '블로그', status: '상태' },
  },
};

export const zh: Translations = {
  nav: { products: '產品', how: '運作方式', pricing: '價格', faq: '常見問題', contact: '聯絡我們', enter: '登入' },
  hero: {
    badge: '5 天免費試用 · 無綁約',
    tagline: [
      '在您睡覺時守護城市的 Whiteout Survival 機器人 —',
      '自動護盾偵測攻擊、開啟護盾並召回部隊。',
      '在您自己的電腦上執行，用手機控制。',
    ],
    cta1: '免費試用 5 天',
    cta2: '看看運作方式 ↓',
  },
  stats: {
    s1v: '24/7', s1l: '機器人在您的電腦上運作',
    s2v: '100% 網頁', s2l: '任何裝置皆可控制',
    s3v: '0 起確認封號', s3l: '在我們的用戶中',
    s4v: '5 天', s4l: '免費試用，隨時取消',
  },
  products: {
    title: '選擇您的 White Bot',
    sub: '同一個機器人，兩種執行方式。',
    downloadable: {
      badge: '現已推出',
      name: 'White Bot Desktop',
      desc: '機器人在您裝有 Windows 和 BlueStacks 的電腦上執行。您自行安裝、完全擁有 — 並隨時隨地透過網頁控制一切。',
      features: [
        '在您的電腦上執行（Windows + BlueStacks）',
        '透過網頁完全控制',
        '採集、練兵、狩獵與自動護盾',
        '🔍 情報：每天內含 5 次查詢',
        '5 天免費試用 — 免信用卡',
      ],
      priceNote: '試用後每月 €11.99',
      cta: '免費試用 5 天',
    },
    cloud: {
      badge: '開發中 — 私人測試',
      name: 'White Bot Cloud',
      desc: '我們在自己的伺服器上為您 24/7 執行機器人，無需安裝任何東西。目前為私人測試，正在完善中。',
      features: [
        '我們為您 24/7 執行',
        '零安裝 — 不需要電腦',
        '完整、無限制的情報功能',
        '名額有限',
      ],
      priceNote: '開放後每月 €49.99 起',
      notifyLabel: '有興趣？開放時我們會寄信通知您：',
      betaAccess: '已在私人測試中？登入',
    },
  },
  cloudNotify: {
    emailPh: 'you@email.com',
    submit: '開放時通知我',
    submitting: '傳送中…',
    successTitle: '您已在名單上！',
    successBody: 'White Bot Cloud 開放時，我們會寄信到這個信箱。',
    errorMsg: '無法傳送。請稍後再試。',
  },
  forwhom: {
    yes: {
      title: '非常適合您，如果…',
      items: [
        '您已有一個發展成熟的 Whiteout Survival 帳號',
        '您有一台可以執行機器人的 Windows 電腦',
        '您想在工作、上課或睡覺時持續成長',
        '您想隨時隨地用手機控制機器人',
      ],
    },
    no: {
      title: '請注意…',
      items: [
        '機器人運作時需要電腦開機並執行 BlueStacks',
        'White Bot 不處理新手教學或新帳號',
        '使用機器人可能違反遊戲服務條款（見常見問題）',
        '遊戲語言必須設為英文或西班牙文',
      ],
    },
  },
  compare: {
    title: '手動 vs White Bot',
    sub: '和您自己做的一樣的操作 — 但一天 24 小時。',
    headers: ['', '手動遊玩', '使用 White Bot'],
    rows: [
      ['活躍時間', '只有您玩的時候', '24 小時 / 7 天'],
      ['資源採集', '受限於您的遊玩時段', '持續且最大化'],
      ['練兵佇列', '有時閒置', '始終運轉'],
      ['狩獵怪物', '一天幾次', '一天數十輪'],
      ['您投入的時間', '每天 2–3 小時', '0 小時'],
      ['手機控制', '只有遊戲本身', '任何瀏覽器的完整面板'],
    ],
  },
  benefits: {
    title: '它為您做的一切',
    sub: '在您自己的電腦上自動化的真實遊戲操作。',
    items: [
      { title: '自動採集', desc: '無需開啟遊戲即可在地圖上採集資源。' },
      { title: '練兵', desc: '讓訓練佇列始終運轉，最大化您的成長。' },
      { title: '自動狩獵', desc: '持續狩獵怪物，累積珍貴道具。' },
      { title: '自動護盾', desc: '監視來襲攻擊：放下一切、從背包啟用護盾並召回行軍中的部隊，保持在保護模式。' },
      { title: '情報', desc: '每天 5 次查詢：來自 White Bot 網路的任何玩家或聯盟的戰力、座標與最後上線。' },
      { title: '網頁控制面板', desc: '從任何瀏覽器（包括手機）設定、暫停與監控您的機器人。' },
    ],
  },
  steps: {
    title: '運作方式',
    sub: '從下載到機器人啟動只要幾分鐘。',
    items: [
      { title: '建立帳號並開始試用', desc: '在產品網站註冊，開始您的 5 天免費。' },
      { title: '下載並安裝用戶端', desc: 'Windows + BlueStacks。安裝指南會一步步引導您。' },
      { title: '用電子郵件啟用', desc: '在用戶端輸入您的電子郵件和啟用碼。完成：用戶端已連線。' },
      { title: '透過網頁控制一切', desc: '從任何裝置設定操作、暫停或監控。機器人在您的電腦上工作。' },
    ],
  },
  trust: {
    title: '安全與隱私',
    sub: '設計上讓控制權始終在您手中。',
    items: [
      { title: '不共享密碼', desc: '您在自己的 BlueStacks 中親自連結遊戲帳號。您的憑證從不離開您的電腦。' },
      { title: '您的電腦，您的控制', desc: '機器人在您的機器上執行，只為驗證授權和驅動面板才與我們的伺服器通訊。' },
      { title: '無綁約', desc: '隨時從網頁取消。存取權維持到已付費期間結束。' },
      { title: 'Stripe 安全付款', desc: '付款由 Stripe 處理。您的卡片資料從不經過我們的伺服器。' },
    ],
  },
  risk: {
    title: '關於風險的透明說明',
    p1: 'White Bot 在您自己電腦上執行的模擬器中自動化遊戲操作。使用第三方軟體可能違反 <strong>Whiteout Survival 的服務條款</strong>，並可能導致遊戲開發商的處罰，包括帳號限制或停權。風險由您的帳號和您的機器承擔。',
    p2: '機器人被設計成像真人玩家一樣行動：可變的操作時間、自然的停頓、真實的循環。<strong>至今，我們的用戶中沒有任何確認的封號。</strong>風險仍然存在，使用本產品即表示用戶接受此風險。請參閱我們的<a href="/terms">使用條款</a>。',
    termsLink: '/terms',
  },
  contact: {
    title: '有問題嗎？',
    sub: '寫信給我們，24 小時內回覆。',
    label: '或直接寄信給我們：',
    fields: { name: '姓名', email: '電子郵件', subject: '主旨', message: '訊息' },
    subjects: { consulta: '一般諮詢', soporte: '技術支援', facturacion: '帳單 / 訂閱', baneo: '問題回報', otro: '其他' },
    submit: '送出訊息', submitting: '傳送中…',
    successTitle: '訊息已送出！', successBody: '我們會在 24 小時內回覆您。',
    errorMsg: '傳送錯誤。請再試一次，或寄信至 whitebot.admin@gmail.com',
    namePh: '您的姓名', emailPh: 'you@email.com', messagePh: '告訴我們您的問題…',
  },
  betaList: {
    title: '別錯過免費測試',
    body: '完整機器人免費至 2026 年 8 月 15 日 — 付費方案 8 月 16 日開始。留下電子郵件，結束前我們會提醒您。',
    emailPh: 'you@email.com',
    submit: '通知我',
    submitting: '傳送中…',
    successTitle: '完成！',
    successBody: '免費測試結束前我們會寄信給您。',
    errorMsg: '無法傳送。請稍後再試。',
    supportNote: '有問題？在應用程式內的支援聊天聯絡我們 — 我們回覆很快。',
  },
  beta: {
    hero: { badge: '免費測試至 8 月 15 日 · 無綁約', cta1: '加入免費測試' },
    stats: { s4v: '免費', s4l: '測試至 2026/8/15 — 免信用卡' },
    stepTrial: {
      title: '建立帳號並加入測試',
      desc: '在產品網站註冊 — 測試期間免費，免信用卡。',
    },
    downloadable: {
      badge: '免費測試',
      trialFeature: '免費測試至 2026 年 8 月 15 日 — 免信用卡',
      priceNote: '免費至 2026 年 8 月 15 日 — 之後每月 €11.99',
      cta: '加入免費測試',
    },
    faq: {
      q: '免費測試包含什麼？',
      a: '2026 年 8 月 15 日前，White Bot Desktop 完全免費：建立帳號、開始測試（免信用卡）並使用完整機器人。8 月 16 日起採用一般模式 — 新用戶 5 天試用及每月 €11.99 訂閱。測試結束前我們會寄信給測試用戶。',
    },
  },
  faq: {
    title: '常見問題',
    items: [
      { q: '使用 White Bot 需要什麼？', a: '一台 Windows 電腦、免費的 BlueStacks 模擬器，以及您的 Whiteout Survival 帳號。機器人安裝在您的電腦上，透過網頁從任何裝置控制。' },
      { q: '需要安裝東西嗎？', a: '需要。與雲端機器人不同，White Bot 在您自己的電腦上執行：按照逐步指南安裝用戶端和 BlueStacks。日常控制 100% 透過網頁 — 無需碰電腦。' },
      { q: '電腦關機時機器人還能運作嗎？', a: '不能。機器人在您的電腦上執行，所以機器必須開著並開啟 BlueStacks。您可以關閉瀏覽器並隨時遠端控制機器人；但它無法在機器關機時工作。' },
      { q: '適用於新帳號嗎？', a: '不適用。White Bot 是為擁有成熟帳號的玩家設計的。系統不處理新手教學或帳號建立。使用機器人前，您的帳號需要完全就緒。' },
      { q: '使用 White Bot 會被封號嗎？', a: '有固有風險。使用自動化軟體可能違反 Whiteout Survival 的服務條款。White Bot 被設計成模仿真人玩家行為：隨機操作時間、自然停頓、真實循環。至今我們的用戶中沒有確認的封號。機器人在您的電腦上以您的帳號執行：風險由您承擔並明確接受（見使用條款）。' },
      { q: '如果被封號怎麼辦？', a: 'White Bot 提供自動化軟體；不保證遊戲內結果或帳號在遊戲開發商面前的安全。若發生處罰，我們逐案評估。明顯由我方技術錯誤造成的封號，將評估按比例退款。因使用條款中已接受的機器人固有風險導致的封號不產生自動退款。' },
      { q: '如何連結我的遊戲帳號？', a: '您自己操作：像在手機上一樣，在 BlueStacks 中登入您的帳號。我們從不看見或儲存您的憑證 — 它們從不離開您的電腦。' },
      { q: '5 天試用包含什麼？', a: '5 天完整機器人，免信用卡。建立帳號，點「開始免費試用」並下載用戶端 — 我們不要求任何付款資料。試用結束後機器人停止；如果喜歡，以每月 €11.99 訂閱並從原處繼續（設定保留）。每個帳號和每台電腦限一次試用。' },
      { q: '自動護盾如何運作？', a: '機器人工作時會監視來襲攻擊。確認攻擊後，它會停止一切、從背包啟用護盾、召回行軍中的部隊，並保持在保護模式直到您恢復。注意：它使用您背包中已有的護盾（不會購買），且不是對瞬間攻擊的絕對保證。' },
      { q: '遊戲需要設定什麼語言？', a: '英文或西班牙文。您可以隨時從網頁更改設定的遊戲語言。' },
      { q: '我可以隨時暫停或停止機器人嗎？', a: '可以。從網頁面板可以立即停止、暫停或重新設定機器人，任何裝置皆可。' },
      { q: '如何取消訂閱？', a: '隨時可從網頁取消。存取權維持到目前計費期間結束。無綁約、無違約金。' },
      { q: 'White Bot Cloud 是什麼？', a: '這是託管版本：機器人在我們的伺服器上 24/7 執行，零安裝，且擁有完整無限制的區域情報（Desktop 內含每天 5 次查詢）。目前開發中，處於私人測試。開放後將是進階方案（每月 €49.99 起）。在產品區留下電子郵件，我們會通知您。' },
    ],
  },
  blog: {
    sectionTitle: '指南與策略',
    sectionSub: '學習如何在 Whiteout Survival 中更快成長。',
    readMore: '閱讀指南 →',
    viewAll: '查看所有指南',
  },
  footer: {
    copy: '© 2026 White Bot · 與 Whiteout Survival 或 Century Games 無關',
    links: { enter: '登入', faq: '常見問題', contact: '聯絡我們', privacy: '隱私政策', terms: '使用條款', blog: '部落格', status: '狀態' },
  },
};

export const ja: Translations = {
  nav: { products: '製品', how: '仕組み', pricing: '料金', faq: 'FAQ', contact: 'お問い合わせ', enter: 'ログイン' },
  hero: {
    badge: '5日間無料体験 · 契約縛りなし',
    tagline: [
      'あなたが眠っている間も都市を守るWhiteout Survivalボット —',
      'オートシールドが攻撃を検知し、シールドを張って部隊を呼び戻します。',
      '自分のPCで動作。スマホから操作。',
    ],
    cta1: '5日間無料で試す',
    cta2: '仕組みを見る ↓',
  },
  stats: {
    s1v: '24/7', s1l: 'あなたのPCでボットが稼働',
    s2v: '100%ウェブ', s2l: 'どの端末からも操作可能',
    s3v: '確認されたBAN 0件', s3l: 'ユーザーの中で',
    s4v: '5日間', s4l: '無料体験、いつでも解約可',
  },
  products: {
    title: 'あなたのWhite Botを選ぶ',
    sub: '同じボット、2つの動かし方。',
    downloadable: {
      badge: '提供中',
      name: 'White Bot Desktop',
      desc: 'ボットはWindowsとBlueStacksを入れたあなたのPCで動きます。自分でインストールして所有し — どこにいてもウェブからすべてを操作できます。',
      features: [
        '自分のPCで動作（Windows + BlueStacks）',
        'ウェブから完全操作',
        '採集・部隊訓練・狩猟・オートシールド',
        '🔍 インテリジェンス：1日5回の検索付き',
        '5日間無料体験 — カード不要',
      ],
      priceNote: '体験後は月額€11.99',
      cta: '5日間無料で試す',
    },
    cloud: {
      badge: '開発中 — プライベートベータ',
      name: 'White Bot Cloud',
      desc: '当社のサーバーでボットを24時間365日代行運用。インストール不要です。完成までプライベートベータで運用中。',
      features: [
        '24/7で代行運用',
        'インストールゼロ — PC不要',
        '完全・無制限のインテリジェンス',
        '席数限定',
      ],
      priceNote: '開放時は月額€49.99から',
      notifyLabel: '興味がありますか？開放時にメールでお知らせします：',
      betaAccess: 'すでにプライベートベータ参加中？ログイン',
    },
  },
  cloudNotify: {
    emailPh: 'you@email.com',
    submit: '開放されたら知らせて',
    submitting: '送信中…',
    successTitle: 'リストに登録されました！',
    successBody: 'White Bot Cloudが開放されたら、このメールにご連絡します。',
    errorMsg: '送信できませんでした。しばらくしてからもう一度お試しください。',
  },
  forwhom: {
    yes: {
      title: 'こんな方にぴったり…',
      items: [
        'すでに育成済みのWhiteout Survivalアカウントを持っている',
        'ボットを動かせるWindows PCがある',
        '仕事・勉強・睡眠の間も成長したい',
        'どこからでもスマホでボットを操作したい',
      ],
    },
    no: {
      title: 'ご注意…',
      items: [
        'ボットの稼働中はPCの電源が入りBlueStacksが起動している必要があります',
        'White Botはチュートリアルや新規アカウントには対応しません',
        'ボットの使用はゲームの利用規約に違反する可能性があります（FAQ参照）',
        'ゲームの言語は英語またはスペイン語に設定する必要があります',
      ],
    },
  },
  compare: {
    title: '手動 vs White Bot',
    sub: '自分でやるのと同じ操作 — ただし1日24時間。',
    headers: ['', '手動プレイ', 'White Botなら'],
    rows: [
      ['アクティブ時間', 'プレイ中だけ', '24時間 / 週7日'],
      ['資源採集', 'プレイ時間に限定', '継続的かつ最大化'],
      ['部隊キュー', '空になりがち', '常に稼働'],
      ['モンスター狩り', '1日数回', '1日数十サイクル'],
      ['あなたの時間', '毎日2〜3時間', '0時間'],
      ['スマホ操作', 'ゲームアプリのみ', 'どのブラウザでもフルパネル'],
    ],
  },
  benefits: {
    title: 'ボットがやってくれること',
    sub: '自分のPCで自動化される、実際のゲーム内アクション。',
    items: [
      { title: 'オート採集', desc: 'ゲームを開かなくてもマップで資源を採集します。' },
      { title: '部隊訓練', desc: '訓練キューを常に稼働させ、成長を最大化します。' },
      { title: 'オート狩猟', desc: 'モンスターを狩り続けて貴重なアイテムを蓄積します。' },
      { title: 'オートシールド', desc: '攻撃を監視：すべてを中断し、バッグからシールドを発動して行軍中の部隊を呼び戻し、保護モードを維持します。' },
      { title: 'インテリジェンス', desc: '1日5回の検索：White Botネットワークから任意のプレイヤー・同盟の戦力、座標、最終ログイン。' },
      { title: 'ウェブ操作パネル', desc: 'スマホを含むあらゆるブラウザからボットを設定・停止・監視。' },
    ],
  },
  steps: {
    title: '仕組み',
    sub: 'ダウンロードからボット稼働まで数分。',
    items: [
      { title: 'アカウントを作成して体験開始', desc: '製品サイトで登録し、5日間の無料体験を始めましょう。' },
      { title: 'クライアントをダウンロード・インストール', desc: 'Windows + BlueStacks。セットアップガイドが各ステップを案内します。' },
      { title: 'メールで有効化', desc: 'クライアントにメールアドレスと認証コードを入力。これで完了：クライアント接続済み。' },
      { title: 'すべてウェブから操作', desc: 'どの端末からでもアクションを設定・停止・監視。ボットはあなたのPCで働きます。' },
    ],
  },
  trust: {
    title: 'セキュリティとプライバシー',
    sub: '主導権が常にあなたにあるよう設計されています。',
    items: [
      { title: 'パスワードの共有なし', desc: '自分のBlueStacksでゲームアカウントを自分で連携します。認証情報はPCの外へ出ません。' },
      { title: 'あなたのPC、あなたの管理', desc: 'ボットはあなたのマシンで動作し、ライセンス確認とパネル稼働のためだけに当社サーバーと通信します。' },
      { title: '縛りなし', desc: 'いつでもウェブから解約できます。支払い済み期間の終わりまでアクセスは有効です。' },
      { title: 'Stripeによる安全な決済', desc: '決済はStripeが処理します。カード情報が当社サーバーに触れることはありません。' },
    ],
  },
  risk: {
    title: 'リスクについての透明性',
    p1: 'White Botは、あなたのPC上のエミュレーター内でゲーム操作を自動化します。サードパーティ製ソフトの使用は<strong>Whiteout Survivalの利用規約</strong>に違反する可能性があり、アカウントの制限や停止を含む、ゲーム開発元によるペナルティにつながる恐れがあります。リスクはあなたのアカウントとマシンが負います。',
    p2: 'ボットは人間のプレイヤーのように振る舞うようプログラムされています：可変のアクション間隔、自然な休止、現実的なサイクル。<strong>現在まで、ユーザーの中で確認されたBANはありません。</strong>それでもリスクは存在し、製品を使用することでユーザーはこれを受け入れます。<a href="/terms">利用規約</a>をご覧ください。',
    termsLink: '/terms',
  },
  contact: {
    title: '質問がありますか？',
    sub: 'ご連絡いただければ24時間以内に返信します。',
    label: 'または直接メールで：',
    fields: { name: '名前', email: 'メール', subject: '件名', message: 'メッセージ' },
    subjects: { consulta: '一般的な質問', soporte: '技術サポート', facturacion: '請求 / サブスクリプション', baneo: '問題の報告', otro: 'その他' },
    submit: '送信', submitting: '送信中…',
    successTitle: '送信しました！', successBody: '24時間以内にご返信します。',
    errorMsg: '送信エラー。もう一度試すか、whitebot.admin@gmail.com までメールしてください。',
    namePh: 'お名前', emailPh: 'you@email.com', messagePh: 'ご質問をどうぞ…',
  },
  betaList: {
    title: '無料ベータをお見逃しなく',
    body: '2026年8月15日までフル機能のボットが無料 — 有料プランは8月16日開始。メールを残していただければ、終了前にお知らせします。',
    emailPh: 'you@email.com',
    submit: '知らせを受け取る',
    submitting: '送信中…',
    successTitle: '完了！',
    successBody: '無料ベータ終了前にメールでお知らせします。',
    errorMsg: '送信できませんでした。しばらくしてからもう一度お試しください。',
    supportNote: '質問は？アプリ内のサポートチャットへ — すぐ答えます。',
  },
  beta: {
    hero: { badge: '8月15日まで無料ベータ · 契約縛りなし', cta1: '無料ベータに参加' },
    stats: { s4v: '無料', s4l: '2026年8月15日までベータ — カード不要' },
    stepTrial: {
      title: 'アカウントを作成してベータに参加',
      desc: '製品サイトで登録 — ベータ期間中は無料、カード不要。',
    },
    downloadable: {
      badge: '無料ベータ',
      trialFeature: '2026年8月15日まで無料ベータ — カード不要',
      priceNote: '2026年8月15日まで無料 — その後は月額€11.99',
      cta: '無料ベータに参加',
    },
    faq: {
      q: '無料ベータには何が含まれますか？',
      a: '2026年8月15日まで、White Bot Desktopは完全無料です：アカウントを作成し、ベータを開始（カード不要）してフル機能のボットをお使いください。8月16日からは通常モデル — 新規ユーザーは5日間体験、月額€11.99のサブスクリプション — が適用されます。ベータユーザーには終了前にメールでお知らせします。',
    },
  },
  faq: {
    title: 'よくある質問',
    items: [
      { q: 'White Botを使うには何が必要ですか？', a: 'Windows PC、無料エミュレーターのBlueStacks、そしてあなたのWhiteout Survivalアカウント。ボットはPCにインストールし、どの端末からでもウェブで操作します。' },
      { q: '何かインストールが必要ですか？', a: 'はい。クラウドボットと違い、White Botはあなた自身のPCで動きます：ステップバイステップのガイドに従ってクライアントとBlueStacksをインストールします。日々の操作は100%ウェブ — PCに触れる必要はありません。' },
      { q: 'PCの電源が切れていてもボットは動きますか？', a: 'いいえ。ボットはあなたのPCで動くため、BlueStacksを開いた状態でマシンの電源が入っている必要があります。ブラウザは閉じてよく、いつでもリモートで操作できます；ただしマシンの電源が切れた状態では動作できません。' },
      { q: '新規アカウントでも使えますか？', a: 'いいえ。White Botは育成済みアカウントを持つプレイヤー向けに設計されています。序盤チュートリアルやアカウント作成には対応しません。ボットを使う前にアカウントが完全にプレイ可能な状態である必要があります。' },
      { q: 'White Botの使用でBANされることはありますか？', a: 'はい、固有のリスクがあります。自動化ソフトの使用はWhiteout Survivalの利用規約に違反する可能性があります。White Botは人間のプレイヤーの振る舞いを模倣するよう作られています：ランダムなアクション間隔、自然な休止、現実的なサイクル。現在まで確認されたBANはありません。ボットはあなたのPCであなたのアカウントを動かします：リスクはあなたのものであり、明示的に受け入れることになります（利用規約参照）。' },
      { q: 'BANされたらどうなりますか？', a: 'White Botは自動化ソフトウェアを提供するものであり、ゲーム内の成果やゲーム開発元に対するアカウントの安全は保証しません。処罰が発生した場合は個別に評価します。当社の技術的ミスが明確な原因のBANは、相応の返金を検討します。利用規約で受け入れたボット固有のリスクによるBANは自動返金の対象になりません。' },
      { q: 'ゲームアカウントはどう連携しますか？', a: 'ご自身で行います：スマホでやるのと同じように、BlueStacks内でアカウントにログインするだけ。当社が認証情報を見たり保存したりすることはありません — PCの外に出ません。' },
      { q: '5日間体験には何が含まれますか？', a: 'カード不要でフル機能のボットが5日間。アカウントを作成し、「無料体験を開始」を押してクライアントをダウンロード — 支払い情報は一切求めません。体験が終わるとボットは停止します。気に入ったら月額€11.99で購読し、そのまま続きから（設定は保持）。体験はアカウントごと・PCごとに1回です。' },
      { q: 'オートシールドはどう動きますか？', a: 'ボットの稼働中、来襲する攻撃を監視します。攻撃を確認すると、すべてを停止し、バッグからシールドを発動し、行軍中の部隊を呼び戻して、あなたが再開するまで保護モードを維持します。注意：すでにバッグにあるシールドを使います（購入はしません）。また、即時攻撃への絶対的な保証ではありません。' },
      { q: 'ゲームの言語は何にすべきですか？', a: '英語またはスペイン語。設定したゲーム言語はいつでもウェブから変更できます。' },
      { q: 'ボットはいつでも止められますか？', a: 'はい。ウェブパネルから、どの端末でも即座にボットを停止・一時停止・再設定できます。' },
      { q: 'サブスクリプションはどう解約しますか？', a: 'いつでもウェブから解約できます。現在の請求期間の終わりまでアクセスは有効です。縛りも違約金もありません。' },
      { q: 'White Bot Cloudとは？', a: 'ホスト版です：ボットが当社サーバーで24時間365日動き、インストールはゼロ、地域インテリジェンスは完全無制限（Desktopは1日5回の検索付き）。現在開発中でプライベートベータです。開放時はプレミアムプラン（月額€49.99から）になります。製品セクションにメールを残していただければお知らせします。' },
    ],
  },
  blog: {
    sectionTitle: 'ガイド＆戦略',
    sectionSub: 'Whiteout Survivalでより速く成長する方法を学びましょう。',
    readMore: 'ガイドを読む →',
    viewAll: 'すべてのガイド',
  },
  footer: {
    copy: '© 2026 White Bot · Whiteout SurvivalおよびCentury Gamesとは無関係です',
    links: { enter: 'ログイン', faq: 'FAQ', contact: 'お問い合わせ', privacy: 'プライバシーポリシー', terms: '利用規約', blog: 'ブログ', status: 'ステータス' },
  },
};

export const tr: Translations = {
  nav: { products: 'Ürünler', how: 'Nasıl çalışır', pricing: 'Fiyatlar', faq: 'SSS', contact: 'İletişim', enter: 'Giriş yap' },
  hero: {
    badge: '5 gün ücretsiz deneme · Taahhüt yok',
    tagline: [
      'Siz uyurken şehrinizi koruyan Whiteout Survival botu —',
      'Oto Kalkan saldırıları algılar, kalkanı açar ve askerlerinizi geri çağırır.',
      'Kendi PC\'nizde çalışır. Telefonunuzdan kontrol edilir.',
    ],
    cta1: '5 gün ücretsiz dene',
    cta2: 'Nasıl çalıştığını gör ↓',
  },
  stats: {
    s1v: '7/24', s1l: 'Bot sizin PC\'nizde çalışır',
    s2v: '%100 web', s2l: 'Her cihazdan kontrol',
    s3v: '0 doğrulanmış ban', s3l: 'Kullanıcılarımız arasında',
    s4v: '5 gün', s4l: 'Ücretsiz deneme, istediğiniz zaman iptal',
  },
  products: {
    title: 'White Bot\'unuzu seçin',
    sub: 'Aynı bot, iki çalıştırma şekli.',
    downloadable: {
      badge: 'Şimdi kullanılabilir',
      name: 'White Bot Desktop',
      desc: 'Bot, Windows ve BlueStacks kurulu PC\'nizde çalışır. Kendiniz kurar, size ait olur — ve nerede olursanız olun her şeyi webden kontrol edersiniz.',
      features: [
        'Kendi PC\'nizde çalışır (Windows + BlueStacks)',
        'Webden tam kontrol',
        'Toplama, asker eğitimi, av ve Oto Kalkan',
        '🔍 İstihbarat: günde 5 sorgu dahil',
        '5 gün ücretsiz deneme — kartsız',
      ],
      priceNote: 'Denemeden sonra aylık €11,99',
      cta: '5 gün ücretsiz dene',
    },
    cloud: {
      badge: 'Geliştiriliyor — özel beta',
      name: 'White Bot Cloud',
      desc: 'Botu sizin için kendi sunucularımızda 7/24 çalıştırıyoruz, hiçbir kurulum yok. Bitirene kadar özel betada.',
      features: [
        'Sizin için 7/24 biz çalıştırıyoruz',
        'Sıfır kurulum — PC gerekmez',
        'Tam, sınırsız İstihbarat',
        'Sınırlı kontenjan',
      ],
      priceNote: 'Açıldığında aylık €49,99\'dan itibaren',
      notifyLabel: 'İlgileniyor musunuz? Açıldığında e-posta atarız:',
      betaAccess: 'Zaten özel betada mısınız? Giriş yapın',
    },
  },
  cloudNotify: {
    emailPh: 'sen@eposta.com',
    submit: 'Açılınca haber ver',
    submitting: 'Gönderiliyor…',
    successTitle: 'Listedesiniz!',
    successBody: 'White Bot Cloud kapılarını açtığında bu adrese yazacağız.',
    errorMsg: 'Gönderilemedi. Lütfen birazdan tekrar deneyin.',
  },
  forwhom: {
    yes: {
      title: 'Tam size göre, eğer…',
      items: [
        'Zaten gelişmiş bir Whiteout Survival hesabınız varsa',
        'Botun çalışabileceği bir Windows PC\'niz varsa',
        'Çalışırken, okurken veya uyurken ilerlemek istiyorsanız',
        'Botu her yerden telefonunuzla kontrol etmek istiyorsanız',
      ],
    },
    no: {
      title: 'Akılda bulundurun…',
      items: [
        'Bot çalışırken PC\'nizin açık ve BlueStacks\'in çalışıyor olması gerekir',
        'White Bot eğitimleri veya yeni hesapları yönetmez',
        'Bot kullanmak oyunun Hizmet Şartlarını ihlal edebilir (SSS\'ye bakın)',
        'Oyun İngilizce veya İspanyolca olmalıdır',
      ],
    },
  },
  compare: {
    title: 'Manuel vs White Bot',
    sub: 'Kendinizin yapacağı aynı işlemler — ama günde 24 saat.',
    headers: ['', 'Manuel oynayarak', 'White Bot ile'],
    rows: [
      ['Aktif saatler', 'Sadece oynarken', '24 sa / 7 gün'],
      ['Kaynak toplama', 'Oturumlarınızla sınırlı', 'Sürekli ve maksimum'],
      ['Asker sırası', 'Bazen boş kalır', 'Her zaman aktif'],
      ['Canavar avı', 'Günde birkaç', 'Günde onlarca tur'],
      ['Harcadığınız zaman', 'Günde 2–3 saat', '0 saat'],
      ['Mobil kontrol', 'Sadece oyunun kendisi', 'Her tarayıcıda tam panel'],
    ],
  },
  benefits: {
    title: 'Sizin için yaptığı her şey',
    sub: 'Kendi PC\'nizde otomatikleşen gerçek oyun içi işlemler.',
    items: [
      { title: 'Oto Toplama', desc: 'Oyunu açmanıza gerek kalmadan haritada kaynak toplar.' },
      { title: 'Asker Eğitimi', desc: 'İlerlemenizi en üst düzeye çıkarmak için eğitim sıralarını hep aktif tutar.' },
      { title: 'Oto Av', desc: 'Değerli eşyalar biriktirmek için sürekli canavar avlar.' },
      { title: 'Oto Kalkan', desc: 'Gelen saldırıları izler: her şeyi bırakır, çantanızdan bir kalkan etkinleştirir ve yürüyüşteki askerlerinizi geri çağırıp korumalı modda kalır.' },
      { title: 'İstihbarat', desc: 'Günde 5 sorgu: White Bot ağından herhangi bir oyuncu veya ittifakın gücü, koordinatları ve son görülmesi.' },
      { title: 'Web kontrol paneli', desc: 'Botunuzu telefon dahil her tarayıcıdan yapılandırın, durdurun ve izleyin.' },
    ],
  },
  steps: {
    title: 'Nasıl çalışır',
    sub: 'İndirmeden aktif bota dakikalar içinde.',
    items: [
      { title: 'Hesabınızı oluşturun ve denemeyi başlatın', desc: 'Ürün sitesine kaydolun ve 5 ücretsiz gününüzü başlatın.' },
      { title: 'İstemciyi indirip kurun', desc: 'Windows + BlueStacks. Kurulum rehberi her adımda yol gösterir.' },
      { title: 'E-postanızla etkinleştirin', desc: 'İstemciye e-postanızı ve etkinleştirme kodunu girin. Bitti: istemci bağlı.' },
      { title: 'Her şeyi webden kontrol edin', desc: 'Her cihazdan işlemleri ayarlayın, durdurun veya izleyin. Bot sizin PC\'nizde çalışır.' },
    ],
  },
  trust: {
    title: 'Güvenlik ve gizlilik',
    sub: 'Kontrol her zaman sizde kalacak şekilde tasarlandı.',
    items: [
      { title: 'Paylaşılan şifre yok', desc: 'Oyun hesabınızı kendi BlueStacks\'inizde kendiniz bağlarsınız. Kimlik bilgileriniz PC\'nizden asla çıkmaz.' },
      { title: 'Sizin PC\'niz, sizin kontrolünüz', desc: 'Bot sizin makinenizde çalışır ve sunucularımızla yalnızca lisansınızı doğrulamak ve panelinizi beslemek için konuşur.' },
      { title: 'Taahhüt yok', desc: 'Webden istediğiniz zaman iptal edin. Erişim, ödenmiş dönemin sonuna kadar aktif kalır.' },
      { title: 'Stripe ile güvenli ödeme', desc: 'Ödemeleri Stripe işler. Kart bilgileriniz sunucularımıza asla dokunmaz.' },
    ],
  },
  risk: {
    title: 'Risk konusunda şeffaflık',
    p1: 'White Bot, kendi PC\'nizde çalışan bir emülatörde oyun içi işlemleri otomatikleştirir. Üçüncü taraf yazılım kullanmak <strong>Whiteout Survival Hizmet Şartlarını</strong> ihlal edebilir ve hesap kısıtlaması veya askıya alınması dahil, oyun geliştiricisinin cezalarına yol açabilir. Risk, hesabınıza ve makinenize aittir.',
    p2: 'Bot, bir insan oyuncu gibi davranacak şekilde programlanmıştır: değişken işlem zamanlamaları, doğal duraklamalar ve gerçekçi döngüler. <strong>Bugüne kadar kullanıcılarımız arasında doğrulanmış hiçbir ban yok.</strong> Risk yine de vardır ve ürünü kullanarak kullanıcı bunu kabul eder. <a href="/terms">Kullanım Şartlarımıza</a> bakın.',
    termsLink: '/terms',
  },
  contact: {
    title: 'Sorunuz mu var?',
    sub: 'Bize yazın, 24 saat içinde yanıtlayalım.',
    label: 'Veya doğrudan e-posta gönderin:',
    fields: { name: 'İsim', email: 'E-posta', subject: 'Konu', message: 'Mesaj' },
    subjects: { consulta: 'Genel soru', soporte: 'Teknik destek', facturacion: 'Fatura / abonelik', baneo: 'Sorun bildirimi', otro: 'Diğer' },
    submit: 'Mesaj gönder', submitting: 'Gönderiliyor…',
    successTitle: 'Mesaj gönderildi!', successBody: '24 saat içinde size döneceğiz.',
    errorMsg: 'Gönderme hatası. Tekrar deneyin veya whitebot.admin@gmail.com adresine yazın.',
    namePh: 'Adınız', emailPh: 'sen@eposta.com', messagePh: 'Sorunuzu anlatın…',
  },
  betaList: {
    title: 'Ücretsiz betayı kaçırmayın',
    body: 'Tam bot 15 Ağustos 2026\'ya kadar ücretsiz — ücretli planlar 16 Ağustos\'ta başlıyor. E-postanızı bırakın, bitmeden hatırlatalım.',
    emailPh: 'sen@eposta.com',
    submit: 'Beni haberdar et',
    submitting: 'Gönderiliyor…',
    successTitle: 'Tamam!',
    successBody: 'Ücretsiz beta bitmeden size e-posta atacağız.',
    errorMsg: 'Gönderilemedi. Lütfen birazdan tekrar deneyin.',
    supportNote: 'Sorular mı? Uygulama içi destek sohbetinden yazın — hızlı yanıtlıyoruz.',
  },
  beta: {
    hero: { badge: '15 Ağustos\'a kadar ücretsiz beta · Taahhüt yok', cta1: 'Ücretsiz betaya katıl' },
    stats: { s4v: 'Ücretsiz', s4l: '15 Ağu 2026\'ya kadar beta — kartsız' },
    stepTrial: {
      title: 'Hesabınızı oluşturun ve betaya katılın',
      desc: 'Ürün sitesine kaydolun — beta boyunca ücretsiz, kartsız.',
    },
    downloadable: {
      badge: 'Ücretsiz beta',
      trialFeature: '15 Ağustos 2026\'ya kadar ücretsiz beta — kartsız',
      priceNote: '15 Ağustos 2026\'ya kadar ücretsiz — sonra aylık €11,99',
      cta: 'Ücretsiz betaya katıl',
    },
    faq: {
      q: 'Ücretsiz beta neleri içeriyor?',
      a: '15 Ağustos 2026\'ya kadar White Bot Desktop tamamen ücretsiz: hesabınızı oluşturun, betayı başlatın (kart gerekmez) ve tam botu kullanın. 16 Ağustos\'ta normal model devreye girer — yeni kullanıcılara 5 günlük deneme ve aylık €11,99 abonelik. Beta kullanıcılarına bitmeden e-posta atacağız.',
    },
  },
  faq: {
    title: 'Sıkça Sorulan Sorular',
    items: [
      { q: 'White Bot kullanmak için ne gerekir?', a: 'Bir Windows PC, ücretsiz BlueStacks emülatörü ve Whiteout Survival hesabınız. Bot PC\'nize kurulur ve her cihazdan webden kontrol edilir.' },
      { q: 'Bir şey kurmam gerekiyor mu?', a: 'Evet. Bulut botlarının aksine White Bot kendi PC\'nizde çalışır: adım adım rehberi izleyerek istemciyi ve BlueStacks\'i kurarsınız. Günlük kontrol %100 web üzerinden — PC\'ye dokunmak gerekmez.' },
      { q: 'PC kapalıyken bot çalışır mı?', a: 'Hayır. Bot PC\'nizde çalışır, bu yüzden makinenin BlueStacks açıkken açık olması gerekir. Tarayıcıyı kapatıp botu istediğiniz an uzaktan kontrol edebilirsiniz; yapamadığı şey, makine kapalıyken çalışmaktır.' },
      { q: 'Yeni hesaplarla çalışır mı?', a: 'Hayır. White Bot, gelişmiş hesapları olan oyuncular için tasarlandı. Sistem başlangıç eğitimlerini veya hesap oluşturmayı yönetmez. Botu kullanmadan önce hesabınızın tamamen hazır olması gerekir.' },
      { q: 'White Bot kullandığım için banlanabilir miyim?', a: 'Evet, doğal bir risk var. Otomasyon yazılımı kullanmak Whiteout Survival\'ın Hizmet Şartlarını ihlal edebilir. White Bot insan oyuncu davranışını taklit edecek şekilde programlandı: rastgele işlem zamanlamaları, doğal duraklamalar ve gerçekçi döngüler. Bugüne kadar kullanıcılarımızda doğrulanmış ban yok. Bot sizin PC\'nizde sizin hesabınızla çalışır: risk sizindir ve bunu açıkça kabul edersiniz (Kullanım Şartlarına bakın).' },
      { q: 'Banlanırsam ne olur?', a: 'White Bot otomasyon yazılımını sağlar; oyun içi sonuçları veya hesabın oyun geliştiricisi karşısındaki güvenliğini garanti etmez. Bir yaptırım olursa her vakayı ayrı değerlendiririz. Bizim teknik hatamızdan kaynaklandığı açık bir ban, orantılı iade için incelenir. Kullanım Şartlarında kabul edilen bot riskinden doğan banlar otomatik iade doğurmaz.' },
      { q: 'Oyun hesabımı nasıl bağlarım?', a: 'Kendiniz yaparsınız: telefonunuzda yaptığınız gibi BlueStacks içinde hesabınıza giriş yaparsınız. Kimlik bilgilerinizi asla görmeyiz veya saklamayız — PC\'nizden çıkmazlar.' },
      { q: '5 günlük deneme neleri içerir?', a: 'Kartsız, TAM botla 5 gün. Hesabınızı oluşturun, "Ücretsiz denemeyi başlat"a basın ve istemciyi indirin — hiçbir ödeme bilgisi istemeyiz. Deneme bitince bot durur; beğenirseniz aylık €11,99\'a abone olun ve kaldığınız yerden devam edin (ayarlarınız korunur). Hesap ve PC başına bir deneme.' },
      { q: 'Oto Kalkan nasıl çalışır?', a: 'Bot çalışırken gelen saldırıları izler. Bir saldırıyı doğrularsa her şeyi durdurur, çantanızdan bir kalkan etkinleştirir, yürüyüşteki askerlerinizi geri çağırır ve siz devam edene kadar korumalı modda kalır. Not: Zaten çantanızda olan kalkanları kullanır (satın almaz) ve anlık saldırılara karşı mutlak bir garanti değildir.' },
      { q: 'Oyun hangi dilde olmalı?', a: 'İngilizce veya İspanyolca. Yapılandırılan oyun dilini istediğiniz zaman webden değiştirebilirsiniz.' },
      { q: 'Botu istediğim an durdurabilir miyim?', a: 'Evet. Web panelinden botu anında durdurabilir, duraklatabilir veya yeniden yapılandırabilirsiniz, her cihazdan.' },
      { q: 'Aboneliğimi nasıl iptal ederim?', a: 'İstediğiniz zaman webden iptal edebilirsiniz. Erişim, mevcut fatura döneminin sonuna kadar aktif kalır. Taahhüt yok, ceza yok.' },
      { q: 'White Bot Cloud nedir?', a: 'Barındırılan sürümdür: bot bizim sunucularımızda 7/24 çalışır, sıfır kurulum ve tam, sınırsız bölge İstihbaratı ile (Desktop günde 5 sorgu içerir). Geliştirme aşamasında, özel betada. Açıldığında premium bir seviye olacak (aylık €49,99\'dan itibaren). Ürünler bölümüne e-postanızı bırakın, haber verelim.' },
    ],
  },
  blog: {
    sectionTitle: 'Rehberler ve stratejiler',
    sectionSub: 'Whiteout Survival\'da nasıl daha hızlı büyüyeceğinizi öğrenin.',
    readMore: 'Rehberi oku →',
    viewAll: 'Tüm rehberler',
  },
  footer: {
    copy: '© 2026 White Bot · Whiteout Survival veya Century Games ile bağlantılı değildir',
    links: { enter: 'Giriş yap', faq: 'SSS', contact: 'İletişim', privacy: 'Gizlilik politikası', terms: 'Kullanım şartları', blog: 'Blog', status: 'Durum' },
  },
};
